module.exports = __webpack_public_path__ + "img/csv.76d2e38b.svg";